import { Component, EventEmitter, ViewChild, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, FormGroup, FormControl, Validators, ReactiveFormsModule } from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { UserService } from "../../services/user.service";
import { IUserCrud, IGroupedUsers, IPage } from "../../interfaces/ilogin";
import { EmitterService } from "../../services/emitter.service";
import { IButton } from "../../interfaces/ibuttons";
import { DownloadFileComponent } from "../downloadfile/downloadfile.component";
import { DataExportService } from "../../services/dataexport.service";
import { ToastrService } from "ngx-toastr";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { UserRoleToggleDirective } from "../../directives/userroletoggle.directive";
import { UsersFilterPipe } from "../../pipes/usersfilter.pipe";
import { UsersImportFileComponent } from "../usersbulkupload/usersimportFile.component";

@Component({
    selector: "users",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, UserRoleToggleDirective, UsersImportFileComponent, DownloadFileComponent],
    templateUrl: "./users.component.html",
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class UsersComponent implements OnInit {
    groupedUsers: IGroupedUsers[] = new Array();
    users: IUserCrud[] = new Array();
    allUsers: IUserCrud[] = new Array();
    hideDisableUpdates: boolean = true;
    headerButtons: IButton[];
    totalItems: number = 0;
    pages: number[] = new Array();
    totalPages: number;
    currentPage: number;
    pageSizes: Array<IPage> = [{ id: 10, text: '10' }, { id: 20, text: '20' }, { id: 30, text: '30' }, { id: 50, text: '50' }, { id: 100, text: '100' }, { id: 0, text: 'ALL' }];
    selectedPageSize: number = 10;
    searchTerm: string;
    userSearch: FormGroup;
    @ViewChild("download") fileDownload: DownloadFileComponent;

    constructor(private userService: UserService, private router: Router, private dataExportService: DataExportService, private toastr: ToastrService) {
        this.userSearch = new FormGroup({
            search: new FormControl()
        });
        let emitter: EventEmitter<any> = EmitterService.get("Create user");
        let button: IButton = { label: "Create user", btnClass: "fa fa-plus ml-2", btnClicked: emitter, disable: false };
        this.headerButtons = [button];
        emitter.subscribe(() => {
            this.addClicked();
        });

        this.userSearch.controls['search'].valueChanges
            .pipe(
                debounceTime(700),
                distinctUntilChanged()
            )
            .subscribe(searchTerm => {
                if (!searchTerm || searchTerm.trim().length >= 3) {
                    this.search(searchTerm);
                }
            });
    }

    ngOnInit(): void {
        // Load initial data on page load
        this.userService.getUsersCount('').subscribe(count => {
            this.totalItems = count;
            this.setPage(1);
        });
    }

    editClicked(user: IUserCrud): void {
        this.router.navigate(["/user", user.id]);
    }

    addClicked(): void {
        this.router.navigate(["/user"]);
    }

    setPage(page: number): void {
        this.currentPage = page;
        this.totalPages = Math.ceil(this.totalItems / (this.selectedPageSize));
        if (this.selectedPageSize > this.totalItems) {
            this.totalPages = 1;
        }
        if (page < 1) {
            page = 1;
        } else if (page > this.totalPages) {
            page = this.totalPages;
        }

        let startPage: number, endPage: number;
        if (this.totalPages <= 10) {
            startPage = 1;
            endPage = this.totalPages;
        } else {
            if (page <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (page + 4 >= this.totalPages) {
                startPage = this.totalPages - 9;
                endPage = this.totalPages;
            } else {
                startPage = page - 5;
                endPage = page + 4;
            }
        }

        this.pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

        this.userService.getPagedUsers(page, this.selectedPageSize, this.searchTerm).subscribe(i => {
            this.groupedUsers = i;
            this.users = this.allUsers.filter(i => !i.disabled);
        });
    }
    setPageSize(pageSize: number): void {
        this.selectedPageSize = pageSize;
        if (pageSize == 0) {//Selected All as page Size
            this.userService.getPagedUsers(this.currentPage, this.selectedPageSize, this.searchTerm).subscribe(i => {
                this.groupedUsers = i;
                this.users = this.allUsers.filter(i => !i.disabled);
            });
        }
        else {
            this.setPage(1);
        }
    }
   
    search(searchValue: string): void {
                this.searchTerm = searchValue;
        if (this.selectedPageSize == 0) {//selected All
            this.searchTerm = searchValue;
            this.userService.getPagedUsers(this.currentPage, this.selectedPageSize, this.searchTerm)
                .pipe(debounceTime(700))
                .subscribe(i => {
                this.groupedUsers = i;
                this.users = this.allUsers.filter(i => !i.disabled);
            });
        }
        else {//need to recalibrate pagination based on search count
            this.userService.getUsersCount(searchValue).subscribe(i => {
                this.totalItems = i;
                this.setPage(1);//calibrating pagination
            });
        }
    }
    downloadTemplateFile(): void {
        this.dataExportService.getUsersImportTemplate().subscribe((res: any) => {
            this.fileDownload.downloadExcel("UserDataImportTemplate", res);
        }, () => this.toastr.error("An error occurred while exporting the data import template"));
    }
}

